export default __webpack_public_path__ + "static/media/list-price-deactive.1aa758fd.svg";